import type { CurrentUser } from '../api';
import { WorkspaceShell } from '../workspace/WorkspaceShell';

/** Signed-in shell: the page tree, editor, trash, search and invites. */
export function Home({
  user,
  onSignedOut,
}: {
  user: CurrentUser;
  onSignedOut: () => void;
}): React.ReactNode {
  return <WorkspaceShell user={user} onSignedOut={onSignedOut} />;
}
